import { FaYoutube, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react'; // Import useState hook
import logo from '../asset/logo.png';
import { Spin as Hamburger } from 'hamburger-react'

const Navbar = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track menu toggle

    // Function to check if the current path matches the link
    const isActive = (path) => location.pathname === path;

    // Toggle the mobile menu
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <header className="bg-creamColor shadow-md font-work-sans poppins-light">
            <nav className="flex justify-between items-center px-4 sm:px-16 ">
                <Link to="/">
                    <img src={logo} alt="logo" width={100} height={30} />
                </Link>

                {/* Main navigation for larger screens */}
                <div className="hidden sm:flex items-center gap-7 text-black text-[17px]">
                    <Link to="/" className={isActive("/") ? "border-b-[1px] border-black" : ""}>
                        <span>Blog</span>
                    </Link>
                    <Link to="/about" className={isActive("/about") ? "border-b-[1px] border-black" : ""}>
                        <span>About</span>
                    </Link>
                    <Link to="/contact" className={isActive("/contact") ? "border-b-[1px] border-black" : ""}>
                        <span>Contact</span>
                    </Link>

                    {/* Social Media Icons */}
                    <div className="flex gap-7">
                        <Link to="https://www.instagram.com/itsbooklore/" target="_blank">
                            <FaInstagram className="hover:text-[#d62976] transition-all" />
                        </Link>
                        <Link to="https://www.youtube.com/@readatbooklore" target="_blank">
                            <FaYoutube className="hover:text-red-500 transition-all" />
                        </Link>
                        <Link to="https://x.com/itsbooklore" target="_blank">
                            <FaTwitter className="hover:text-blue-400 transition-all" />
                        </Link>
                        <Link to="https://www.linkedin.com/company/booklore-in/" target="_blank">
                            <FaLinkedin className="hover:text-[#0077b5] transition-all" />
                        </Link>
                    </div>
                </div>

                {/* Mobile menu button */}
                <div className="sm:hidden flex items-center">
                <Hamburger 
                toggled={isMenuOpen}
                direction="right" 
                size={22}
                onToggle={toggleMenu} 
                />
                </div>
            </nav>

            {/* Mobile menu (with smooth transition) */}
            <div
                className={`sm:hidden flex flex-col items-center gap-4 bg-creamColor  transition-all duration-500 pb-4 ease-in-out
                    ${isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}
            >
                <Link onClick={() => {setIsMenuOpen(false)}} to="/" className={isActive("/") ? "border-b-[1px] border-black" : ""}>
                    <span>Blog</span>
                </Link>
                <Link onClick={() => {setIsMenuOpen(false)}} to="/about" className={isActive("/about") ? "border-b-[1px] border-black" : ""}>
                    <span>About</span>
                </Link>
                <Link onClick={() => {setIsMenuOpen(false)}} to="/contact" className={isActive("/contact") ? "border-b-[1px] border-black" : ""}>
                    <span>Contact</span>
                </Link>

                {/* Social Media Icons */}
                <div className="flex gap-7">
                    <Link onClick={() => {setIsMenuOpen(false)}} to="https://www.instagram.com/itsbooklore/" target="_blank">
                        <FaInstagram className="hover:text-[#d62976] transition-all" />
                    </Link>
                    <Link onClick={() => {setIsMenuOpen(false)}} to="https://www.youtube.com/@readatbooklore" target="_blank">
                        <FaYoutube className="hover:text-red-500 transition-all" />
                    </Link>
                    <Link onClick={() => {setIsMenuOpen(false)}} to="https://x.com/itsbooklore" target="_blank">
                        <FaTwitter className="hover:text-blue-400 transition-all" />
                    </Link>
                    <Link onClick={() => {setIsMenuOpen(false)}} to="https://www.linkedin.com/company/booklore-in/" target="_blank">
                        <FaLinkedin className="hover:text-[#0077b5] transition-all" />
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
